export default __webpack_public_path__ + "static/cDBuMQWP-42c58b67739b18864e35662bf698bbfa.svg";